export const EARLY_PROFILE_TITLE = 'Your Birding Personality Is Taking Shape';
export const EARLY_PROFILE_INTRO = 'Keep recording the outings that matter to you. A few early patterns are already beginning to emerge.';
export const MONTH_LABELS = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];
